
import { useState } from "react";
import { motion } from "framer-motion";
import "../styles/WarehouseSection.scss";

const WarehouseSection = () => {
  const [activeLocation, setActiveLocation] = useState(null);

  const locations = [
    { name: "Jodhpur", description: "Solar Distribution Hub" },
    { name: "Jaipur", description: "Regional Operations Center" },
    { name: "Ganganagar", description: "Manufacturing Support" },
    { name: "Vadodara", description: "Western Region Hub" },
    { name: "Udaipur", description: "Service Center" }
  ];

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const titleVariants = {
    hidden: { opacity: 0, y: -30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.4, 0, 0.2, 1]
      }
    }
  };

  const pinVariants = {
    hidden: {
      opacity: 0,
      scale: 0.8,
      y: 20
    },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.4, 0, 0.2, 1]
      }
    }
  };

  return (
    <section className="warehouse-section section-padding" id="warehouse">
      <div className="container">
        {/* Section Header */}
        <motion.div
          className="section-header text-center mb-5"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={titleVariants}
        >
          <h2 className="section-title">Our Solar Distribution Network</h2>
          <p className="section-subtitle">
            Strategic locations across India ensuring efficient solar project delivery and support
          </p>
        </motion.div>

        {/* Warehouse Map Container */}
        <motion.div
          className="row justify-content-center"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={containerVariants}
        >
          <div className="col-12 col-xl-12">
            <div className="warehouse-map-container">
              <div className="warehouse-map">
                <div className="row justify-content-center">
                  {locations.map((location, index) => (
                    <div key={index} className="col-lg-2 col-md-4 col-6 mb-4 mb-lg-0">
                      <motion.div
                        className={`warehouse-pin h-100 ${activeLocation === index ? "active" : ""}`}
                        variants={pinVariants}
                        whileHover={{
                          y: -5,
                          transition: { duration: 0.3 }
                        }}
                        whileTap={{ scale: 0.95 }}
                        onClick={() => setActiveLocation(activeLocation === index ? null : index)}
                      >
                        <div className="pin-icon-container">
                          <svg className="pin-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                          </svg>
                        </div>
                        <div className="pin-content">
                          <h4 className="pin-label">{location.name}</h4>
                          <p className="pin-description">{location.description}</p>
                        </div>

                        {/* Active indicator */}
                        {activeLocation === index && (
                          <motion.div
                            className="active-indicator"
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            exit={{ scale: 0 }}
                            transition={{ duration: 0.3 }}
                          />
                        )}
                      </motion.div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WarehouseSection;